export interface StaffPresence {
  user_id: string;
  online: boolean;
  last_seen_at?: string;
}

export function formatPresenceLabel(presence?: StaffPresence): string {
  if (!presence) return '';
  if (presence.online) return 'Online';
  if (presence.last_seen_at) {
    const last = new Date(presence.last_seen_at);
    const diffMs = Date.now() - last.getTime();
    if (diffMs < 60_000) return 'Last seen just now';
    const mins = Math.floor(diffMs / 60_000);
    if (mins < 60) return `Last seen ${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `Last seen ${hours}h ago`;
    return `Last seen ${last.toLocaleDateString()}`;
  }
  return 'Offline';
}

interface RoomMember {
  user_id?: string;
}

export function roomPresenceSubtitle(
  room:
    | {
        room_type?: string;
        members: RoomMember[];
      }
    | undefined,
  options: {
    currentUserId?: string;
    presenceByUserId: Record<string, StaffPresence>;
  },
): string {
  if (!room) return '';

  if (room.room_type === 'staff_direct') {
    const other = room.members.find(
      (member) => member.user_id && member.user_id !== options.currentUserId,
    );
    const label = formatPresenceLabel(
      other?.user_id ? options.presenceByUserId[other.user_id] : undefined,
    );
    return label || 'Direct message';
  }

  const count = room.members.length;
  const onlineCount = room.members.filter(
    (member) => member.user_id && options.presenceByUserId[member.user_id]?.online,
  ).length;

  if (onlineCount > 0) {
    return `${count} members · ${onlineCount} online`;
  }
  return `${count} member${count === 1 ? '' : 's'}`;
}
